import { createContext } from 'react';

const SSRDataContext = createContext();

export const { Provider, Consumer } = SSRDataContext;

export default SSRDataContext;
